import { ErrorHandler, Injectable } from '@angular/core'
import { ERROR_LOGGING_PAGES } from './error-logging.config'
import { ErrorSenderService } from './error-sender.service'
import { environment } from '@env/environment'

@Injectable()
export class ModuleErrorHandler implements ErrorHandler {
  constructor(private errorSenderService: ErrorSenderService) {}

  handleError(error: any): void {
    console.error(error)

    const isActivePage = ERROR_LOGGING_PAGES.some((p) => window.location.pathname.includes(p))

    if (environment.environment === 'prod' && !isActivePage) {
      return
    }

    const err = error?.rejection || error

    if (!this.isHttpError(err)) {
      this.errorSenderService.sendError({
        title: err?.message || String(err),
        error_class: 'UnhandledError',
        level: 'error',
        error_message: err?.message || String(err),
        error_callstack: err?.stack || error?.stack || new Error().stack,
      })
    }
  }

  private isHttpError(err: any): boolean {
    return err?.name === 'HttpErrorResponse'
  }
}
